export default __webpack_public_path__ + "static/media/category_28.635dc54a.png";